import React from 'react';
import Style from './About.module.scss';
import Terminal from "./Terminal";
import {Box} from "@mui/material";
import {info} from "../../info/Info";


export default function About({innerRef}) {
    const firstName = info.firstName.toLowerCase()

    function aboutMeText() {
        const firstName = info.firstName.toLowerCase();
    
        return (
            <>
                <p><span style={{color: info.baseColor}}>{firstName}{info.lastName.toLowerCase()} $</span> cd about{firstName}/ </p>
                <p><span style={{color: info.baseColor}}>about{firstName} <span
                    className={Style.green}>(main)</span> $ cat README.md </span></p>
                <div dangerouslySetInnerHTML={{__html: info.bio}}></div>
            </>
        );
    }
    

    function skillsText() {
        return <>
            <p><span style={{color: info.baseColor}}>{firstName}{info.lastName.toLowerCase()} $</span> cd skills/tools
            </p>
            <p><span style={{color: info.baseColor}}>skills/tools <span
                className={Style.green}>(main)</span> $</span> ls</p>
            <p style={{color: info.baseColor}}> TheObvious/</p>
            <ul className={Style.skills}>
                {info.skills.theObvious.map((proficiency, index) => <li key={index}>{proficiency}</li>)}
            </ul>
            <p style={{color: info.baseColor}}> Libraries+Frameworks/ </p>
            <ul className={Style.skills}>
                {info.skills.libraryFrameworks.map((skill, index) => <li key={index}>{skill}</li>)}
                
            </ul>
            <p style={{color: info.baseColor}}> TechStack/ </p>
            <ul className={Style.skills}>
                {info.skills.techStack.map((tech, index) => <li key={index}>{tech}</li>)}
            </ul>
        </>;
    }

    function miscText() {
        return <>
            <p><span style={{color: info.baseColor}}>{firstName}{info.lastName.toLowerCase()} $</span> cd
                hobbies/interests</p>
            <p><span style={{color: info.baseColor}}>hobbies/interests <span
                className={Style.green}>(main)</span> $</span> ls</p>
            <ul>
                {info.hobbies.map((hobby, index) => (
                    <li key={index}><Box component={'span'} mr={'1rem'}>{hobby.emoji}</Box>{hobby.label}</li>
                ))}
            </ul>
        </>;
    }

    return (
        <Box ref={innerRef} display={'flex'} flexDirection={'column'} alignItems={'center'} mt={'3rem'} id={'about'}>
            <Terminal text={aboutMeText()}/>
            <Terminal text={skillsText()}/>
            <Terminal text={miscText()}/>
        </Box>
    )
}